var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name === 'publicLayout')?_c('PublicLayout'):_c('VerticalLayout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }